<template>
  <a-modal
    title="选择链接"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="1000"
  >
    <!-- 操作 -->
    <div class="page-header-index-wide">
      <a-card
        :bordered="false"
        :bodyStyle="{ padding: '16px 0', height: '100%' }"
        :style="{ height: '100%' }"
      >
        <div
          class="account-settings-info-main"
          :class="device"
        >
          <div class="account-settings-info-left">
            <a-menu
              :mode="device == 'mobile' ? 'horizontal' : 'inline'"
              :style="{ border: '0', width: device == 'mobile' ? '560px' : 'auto'}"
              v-model="defaultSelectedKeys"
              type="inner"
              @click="onClick"
            >
              <a-menu-item key="GOODS">
                商品
              </a-menu-item>
              <a-menu-item key="PAGE">
                页面
              </a-menu-item>
            </a-menu>
          </div>
          <div class="account-settings-info-right">
            <div v-show="activeTabKey === 'GOODS'">
              <a-card
                class="card"
                title="商品列表"
                :bordered="true"
              >
                <a-form
                  @submit="handleGoodsQuerySubmit"
                  class="form"
                >
                  <a-row
                    class="form-row"
                    :gutter="16"
                  >
                    <a-col
                      :xl="{span: 12}"
                      :lg="{span: 12}"
                      :md="{span: 24}"
                      :sm="24"
                    >
                      <a-form-item>
                        <a-input
                          v-model="goodsQueryParam.keyWord"
                          placeholder="搜索关键字"
                          allowClear
                        >
                          <a-select
                            slot="addonBefore"
                            v-model="goodsQueryParam.searchType"
                            placeholder="搜索类型"
                            style="width: 100px"
                          >
                            <a-select-option
                              :value="item.id"
                              :key="item.id"
                              v-for="item in goodsSearchTypeDict"
                            >{{ item.name }}</a-select-option>
                          </a-select>
                        </a-input>
                      </a-form-item>
                    </a-col>
                    <a-col
                      :xl="{span: 8, offset: 4}"
                      :lg="{span: 8, offset: 4}"
                      :md="{span: 24}"
                      :sm="24"
                    >
                      <span :style="{ float: 'right', overflow: 'hidden' } || {} ">
                        <a-button
                          type="primary"
                          @click="$refs.goodsTable.refresh(true)"
                        >查询</a-button>
                      </span>
                    </a-col>
                  </a-row>
                </a-form>
                <tcg-table
                  ref="goodsTable"
                  size="default"
                  :columns="goodsColumns"
                  :data="loadGoodsData"
                  :bordered="true"
                  :pageSize.sync="pageSize"
                >
                  <span
                    slot="action"
                    slot-scope="text, record"
                  >
                    <a
                      style="color:green"
                      v-if="!checkIndex('GOODS', record.goods_id)"
                      @click="selectedKey('GOODS', record)"
                    >选择商品</a>
                    <a
                      v-if="checkIndex('GOODS', record.goods_id)"
                      @click="cancelKey('GOODS', record)"
                    >取消选中</a>
                  </span>
                </tcg-table>
              </a-card>
            </div>
            <div v-show="activeTabKey === 'PAGE'">
              <a-card
                class="card"
                title="自定义页面"
                :bordered="true"
              >
                <a-form
                  @submit="handlePageQuerySubmit"
                  class="form"
                >
                  <a-row
                    class="form-row"
                    :gutter="16"
                  >
                    <a-col
                      :xl="{span: 12}"
                      :lg="{span: 12}"
                      :md="{span: 24}"
                      :sm="24"
                    >
                      <a-form-item>
                        <a-input
                          v-model="pageQueryParam.keyWord"
                          placeholder="搜索关键字"
                          allowClear
                        >
                          <a-select
                            slot="addonBefore"
                            v-model="pageQueryParam.searchType"
                            placeholder="搜索类型"
                            style="width: 100px"
                          >
                            <a-select-option
                              :value="item.id"
                              :key="item.id"
                              v-for="item in pageSearchTypeDict"
                            >{{ item.name }}</a-select-option>
                          </a-select>
                        </a-input>
                      </a-form-item>
                    </a-col>
                    <a-col
                      :xl="{span: 8, offset: 4}"
                      :lg="{span: 8, offset: 4}"
                      :md="{span: 24}"
                      :sm="24"
                    >
                      <span :style="{ float: 'right', overflow: 'hidden' } || {} ">
                        <a-button
                          type="primary"
                          @click="$refs.pageTable.refresh(true)"
                        >查询</a-button>
                      </span>
                    </a-col>
                  </a-row>
                </a-form>
                <tcg-table
                  ref="pageTable"
                  size="default"
                  :columns="pageColumns"
                  :data="loadPageData"
                  :bordered="true"
                  :pageSize.sync="pageSize"
                >
                  <span
                    slot="action"
                    slot-scope="text, record"
                  >
                    <a
                      style="color:green"
                      v-if="!checkIndex('PAGE', record.page_id)"
                      @click="selectedKey('PAGE', record)"
                    >选择页面</a>
                    <a
                      v-if="checkIndex('PAGE', record.page_id)"
                      @click="cancelKey('PAGE', record)"
                    >取消选中</a>
                  </span>
                </tcg-table>
              </a-card>
            </div>
          </div>
        </div>
      </a-card>
    </div>
  </a-modal>
</template>

<script>
import { getGoodsList } from '@/api/goods'
import { getPagesList } from '@/api/pages'
import { mixin, mixinDevice } from '@/utils/mixin'
import { TcgTable } from '@/components'

export default {
  name: 'Link',
  components: {
    TcgTable
  },
  mixins: [mixin, mixinDevice],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      selected: {
        id: 0,
        url: '',
        type: ''
      },
      activeTabKey: 'GOODS',
      defaultSelectedKeys: ['GOODS'],
      pageSize: 5,
      goodsQueryParam: {
        searchType: 'name',
        keyWord: ''
      },
      goodsSearchTypeDict: [
        { id: 'name', name: '商品名称' },
        { id: 'id', name: '商品ID' },
        { id: 'category', name: '商品分类' }
      ],
      pageQueryParam: {
        searchType: 'title',
        keyWord: ''
      },
      pageSearchTypeDict: [{ id: 'page_id', name: '页面ID' }, { id: 'title', name: '页面名称' }],
      // 加载数据方法 必须为 Promise 对象
      loadGoodsData: (parameter) => {
        return getGoodsList(Object.assign(parameter, this.goodsQueryParam))
      },
      // 加载数据方法 必须为 Promise 对象
      loadPageData: (parameter) => {
        return getPagesList(Object.assign(parameter, this.pageQueryParam))
      },
      goodsColumns: [
        {
          title: '商品ID',
          dataIndex: 'goods_id',
          width: '80px'
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          width: '120px'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: '60px'
        },
        {
          title: '分类',
          dataIndex: 'category_str',
          width: '120px'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          key: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      pageColumns: [
        {
          title: '页面ID',
          dataIndex: 'page_id',
          width: '80px'
        },
        {
          title: '页面名称',
          dataIndex: 'title',
          width: '120px'
        },
        {
          title: '云码链接',
          dataIndex: 'page_url'
        },
        {
          title: '操作',
          key: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    showModal(item) {
      this.visible = true
      this.selected = item
      this.activeTabKey = item.type
      this.defaultSelectedKeys = [item.type]
    },
    handleOk(e) {
      this.$emit('ok', this.selected)
      this.visible = false
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
    onClick(e) {
      this.activeTabKey = e.key
    },
    checkIndex(type, id) {
      if (this.selected.type === type && this.selected.id === id) {
        return true
      } else {
        return false
      }
    },
    selectedKey(type, record) {
      if (type === 'GOODS') {
        this.selected = {
          id: record.goods_id,
          url: record.goods_url,
          type: 'GOODS'
        }
      } else if (type === 'PAGE') {
        this.selected = {
          id: record.page_id,
          url: record.page_url,
          type: 'PAGE'
        }
      }
    },
    // 取消选中
    cancelKey(type, record) {
      this.selected = {
        id: '',
        url: '',
        type: ''
      }
    },
    handleGoodsQuerySubmit(e) {
      e.preventDefault()
      this.$refs.goodsTable.refresh(true)
      return false
    },
    handlePageQuerySubmit(e) {
      e.preventDefault()
      this.$refs.pageTable.refresh(true)
      return false
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 15px;
}
.account-settings-info-main {
  width: 100%;
  display: flex;
  height: 100%;
  overflow: auto;

  &.mobile {
    display: block;

    .account-settings-info-left {
      border-right: unset;
      border-bottom: 1px solid #e8e8e8;
      width: 100%;
      height: 50px;
      overflow-x: auto;
      overflow-y: scroll;
    }
    .account-settings-info-right {
      padding: 20px 40px;
    }
  }

  .account-settings-info-left {
    border-right: 1px solid #e8e8e8;
    width: 224px;
  }

  .account-settings-info-right {
    flex: 1 1;
    padding: 8px 40px;

    .account-settings-info-title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 12px;
    }
    .account-settings-info-view {
      padding-top: 12px;
    }
  }
}
</style>
